import React from "react";
import AppRoutes from "./routes/AppRoutes";
import "./Style.css";
import "./Responsive.css";

//import "./Darkmode.css";

const App: React.FC = () => {
  return <AppRoutes />;
};

export default App;
